import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Progress from 'antd/lib/progress';

import ProgressFileName from './ProgressFileName';

const ImportLocationsProgressBar = ({
  fileName,
  percent,
  status,
  strokeColor,
  processedCount,
  totalCount,
  unprocessedCount,
  indexedCount,
  notFoundCount,
  requiresAddressLookup,
}) => {
  const hasCountData = totalCount !== undefined;
  const total = totalCount || 0;
  const completed = processedCount || 0;
  const geocodeQueued = unprocessedCount || 0;
  const geocodeNotFound = notFoundCount || 0;
  const indexed = indexedCount || 0;
  const showGeocodingStep = requiresAddressLookup && total > 0;
  const lookupComplete = Math.max(total - geocodeQueued, 0);
  const progressDenominator = showGeocodingStep ? (total * 2) : total;
  const progressNumerator = showGeocodingStep ? (lookupComplete + indexed) : indexed;
  const stagePercent = progressDenominator > 0
    ? Math.round((progressNumerator / progressDenominator) * 100)
    : percent;

  return (
    <Fragment>
      <ProgressFileName fileName={fileName} />
      <Progress strokeColor={strokeColor} percent={stagePercent} status={status} showInfo={false} />
      {hasCountData && (
        <div>{`Overall: ${completed}/${total}`}</div>
      )}
      {showGeocodingStep && (
        <div>{`Looking up addresses: ${lookupComplete}`}</div>
      )}
      {hasCountData && total > 0 && (
        <div>{`Determining Boundaries: ${indexed}`}</div>
      )}
    </Fragment>
  );
};

ImportLocationsProgressBar.propTypes = {
  fileName: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
  status: PropTypes.string,
  strokeColor: PropTypes.string,
  processedCount: PropTypes.number,
  totalCount: PropTypes.number,
  unprocessedCount: PropTypes.number,
  indexedCount: PropTypes.number,
  notFoundCount: PropTypes.number,
  requiresAddressLookup: PropTypes.bool,
};

export default ImportLocationsProgressBar;
